import { useNavigationMenuSlice } from "@redux/slices/navigationMenuSlice";
import { useOrgSettingsSlice } from "@redux/slices/orgSettingsSlice";
import { useEffect, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";

const useGetProfileSettings = (sectionName) => {
  const menuConfiguration = useNavigationMenuSlice();
  const [section, setSection] = useState(null);
  const { t } = useTranslation();
  const { isJbtDisabled } = useOrgSettingsSlice();
  const findSection = (sections) => {
    for (const item of sections) {
      if (item.name === sectionName) {
        return item;
      }
      if (item.sub_section && item.sub_section.length > 0) {
        const subResult = findSection(item.sub_section);
        if (subResult) return subResult;
      }
      if (item.options && item.options.length > 0) {
        const optionResult = findSection(item.options);
        if (optionResult) return optionResult;
      }
    }
    return null;
  };

  useEffect(() => {
    if (menuConfiguration && menuConfiguration.navigationData.sections) {
      const foundSection = findSection(
        menuConfiguration.navigationData.sections
      );
      setSection(foundSection);
    }
  }, [menuConfiguration, sectionName]);
  const customSections = useMemo(() => {
    if (!section || !section?.sub_section) return [];

    return section?.sub_section
      ?.map((subSection) => {
        const options = isJbtDisabled
          ? subSection.options?.filter((option) => option.name !== "jbt_id")
          : subSection.options;
        return {
          title: subSection.name,
          order: subSection.order || 0,
          label: subSection.label,
          hint_label: subSection.hint_label,
          price_modes: subSection.price_modes || [],
          direction: subSection.direction,
          data:
            options?.map((option) => ({
              ...option,
              id: `${option.name}${
                option.params ? JSON.stringify(option.params) : ""
              }`,
              itemLeftText: t(option.label),
              action: option.on_click || option.name,
              leftIcon: option.icon?.data || "",
              order: option.order || 0,
              price_modes: option.price_modes || [],
              width: option.width,
            })) || [],
        };
      })
      ?.filter((subSection) => subSection.data.length > 0)
      ?.sort((a, b) => a.order - b.order);
  }, [section, isJbtDisabled]);
  return customSections;
};

export default useGetProfileSettings;
